<div *ngIf="!hideIt" class="course" fxFlex="100" fxFlex.gt-xs="33" fxFlex.gt-sm="25"
  [@animate]="{ value: '*', params: { y: '100%' } }">
  <div class="menu-root">
    <button class="more_Button" *ngIf="showMoreBtn && !disableCard" mat-icon-button [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu">
      <mat-icon style="line-height: 21px;">more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngIf="showEditBtn" (click)="onClickEditBtn()">
        <mat-icon class="menu-icon">edit
        </mat-icon>{{ 'To Change Title' | translate }}
      </button>
      <button mat-menu-item *ngIf="showCopyBtn" (click)="onClickCopyBtn()">
        <mat-icon class="menu-icon">file_copy
        </mat-icon>{{ 'Copy' | translate }}
      </button>
      <button mat-menu-item *ngIf="showDeactivateBtn" (click)="onClickDeactivateButton()">
        <mat-icon>clear</mat-icon>
        {{ 'Deactivate' | translate }}
      </button>

    </mat-menu>

    <mat-icon *ngIf="showDeleteBtn" (click)="onClickDeleteBtn()" class="menu-icon" title="{{ 'Delete' | translate }}">
      delete
    </mat-icon>


    <!-- <button mat-icon-button aria-label="Example icon-button with a menu" class="menu-icon" style="margin-top: -10px;"
      *ngIf="showMoveBtn" (click)="onClickMoveBtn()">
      <mat-icon>more_vert</mat-icon>
    </button> -->

    <div class="menu-root1" *ngIf="showMoveBtn || showWardDeleteBtn || showWardEditBtn">
      <button class="more_Button" mat-icon-button [matMenuTriggerFor]="menu1"
        aria-label="Example icon-button with a menu">
        <mat-icon style="line-height: 21px;">more_vert</mat-icon>
      </button>
      <mat-menu #menu1="matMenu">
        <button mat-menu-item *ngIf="showMoveBtn" (click)="onClickMoveBtn()">
          <mat-icon class="menu-icon">move_to_inbox
          </mat-icon>{{ 'To Change Union' | translate }}
        </button>
        <button mat-menu-item *ngIf="showWardEditBtn" (click)="onClickWardEditBtn()">
          <mat-icon class="menu-icon">edit
          </mat-icon>{{ 'To Edit' | translate }}
        </button>
        <button mat-menu-item *ngIf="showWardDeleteBtn" (click)="onClickWardDeleteBtn()">
          <mat-icon class="menu-icon">delete
          </mat-icon>{{ 'To Delete' | translate }}
        </button>
      </mat-menu>
    </div>
  </div>

  <div (click)="!disableCard && onCardClick()" class="course-content" fxLayout="column" fxFlex="1 1 auto"
    [ngStyle]="{'cursor':(disableCard) ? 'not-allowed' : 'pointer' }">
    <div [ngClass]="disableCard ? 'disable-header' : 'accent'" class="header" fxLayout="row"
      fxLayoutAlign="center center">
      <div class="category" fxFlex></div>

      <div class="length" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon class="length-icon s-20"></mat-icon>
        <div class="min"></div>
      </div>
    </div>

    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
      <div class="card-title">{{ card_title | translate }}</div>
      <div [innerHTML]="extraContainerHtml" class="card-extra-title">
        {{ extra_title | translate }}
      </div>
    </div>
    <div *ngIf="showFooter" #footer class="footer" fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto">
      <button *ngIf="showTableButton && !disableCard" (click)="clickTableBtn(); $event.stopPropagation()" color="accent"
        mat-raised-button>
        <mat-icon>table_chart</mat-icon>
      </button>

      <button *ngIf="_showShareButton && !disableCard" (click)="onClickShareButton(); $event.stopPropagation()"
        color="accent" mat-raised-button>
        <mat-icon>share</mat-icon>
      </button>
      <button *ngIf="showVoteBtn && !disableCard" (click)="onVoteButtonClick(); $event.stopPropagation()" color="accent"
        mat-raised-button style="padding: 0px">
        <img style="width: 36px" src="../../../assets/images/vote_icon.png" />
      </button>
    </div>
  </div>
</div>

<div *ngIf="showPlaceHolder" class="placeholder-root" fxFlex="100" fxFlex.gt-xs="33" fxFlex.gt-sm="25"
  [@animate]="{ value: '*', params: { y: '100%' } }">
  <div class="course-content placeholder-background" fxLayout="column" fxFlex="1 1 auto">
    <div class="header" fxLayout="row" fxLayoutAlign="center center"></div>

    <div class="footer" fxLayout="row" fxLayoutAlign="center center"></div>
  </div>
</div>